import { Observable, Subscription } from 'rxjs';

import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators, ValidatorFn } from '@angular/forms';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { MatSelectChange } from '@angular/material/select';
import { MatRadioChange } from '@angular/material/radio';
import { MatCheckboxChange } from '@angular/material/checkbox';

import { AppConst } from '../../app-const';
import { EntranceExitTransitDaily } from '../../firestore-models/entrance-exit-transit-daily';
import { EntranceExitEvent } from '../../firestore-models/entrance-exit-event';
import { Exhibit } from '../../firestore-models/exhibit';
import { EntranceExitTransit } from '../../firestore-models/entrance-exit-transit';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';


export interface EntranceExitEntryDialogData {
  daily?: EntranceExitTransitDaily | null;
  event?: EntranceExitEvent | null;
  exhibits?: Exhibit[] | null;  
}

@Component({
  selector: 'app-entrance-exit-transit-daily-dialog',
  templateUrl: './entrance-exit-transit-daily-dialog.component.html',
  styleUrls: ['./entrance-exit-transit-daily-dialog.component.css'],
  standalone: false,
})
export class EntranceExitTransitDailyDialogComponent implements OnInit {

  //入退場管理入退場日次情報情報
  daily!: EntranceExitTransitDaily;

  projectId: string;

  projectLanguages!: Array<ProjectLanguage>;

  event!: EntranceExitEvent;
  exhibits!: Exhibit[];

  constructor(
    public dialogRef: MatDialogRef<EntranceExitTransitDailyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EntranceExitEntryDialogData,
    public dialog: MatDialog,
    private angularFirestore: AngularFirestore,
    private configurationService: ConfigurationService,
    private formBuilder: FormBuilder,
    private translate: TranslateService
  ) {
    this.projectId = this.configurationService.getProjectId();
   }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.daily = this.data.daily!;
    if (this.data.event) {
      this.event = this.data.event;
    }
    this.exhibits = this.data.exhibits!;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
